module.exports = __webpack_public_path__ + "static/vector-shape1-c3bae2923d94465d5ea11e8b7b7e4491.png";